import { Store } from '@/core/store/core.store';
import { _USER_REQUESTS_STORE } from '../enums/user-requests.enum';
import { GetUserRequestsParams } from '../params/user-requests.params';

export class UserRequestsStoreFacade {

  getUserRequests(data: GetUserRequestsParams) {
    return Store.dispatch(_USER_REQUESTS_STORE.GET_USER_REQUESTS, data);
  }

  resetUserRequests() {
    return Store.commit(_USER_REQUESTS_STORE.RESET_USER_REQUESTS);
  }

}